import GlyphIcon from "./GlyphIcon.mjs";

const HeartEmptyIcon = class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M21.272,5.34473A6.28375,6.28375,0,0,0,16.2041,8.11938a.24607.24607,0,0,1-.40039-.00537A6.01148,6.01148,0,0,0,10.838,5.34473a6.79272,6.79272,0,0,0-6.6192,6.58105c0,4.82666,6.13513,8.68115,11.03705,14.06787a.99989.99989,0,0,0,1.48828,0c4.90192-5.38672,11.03717-9.24121,11.03717-14.06787A6.70068,6.70068,0,0,0,21.272,5.34473ZM19.28534,19.80811c-.96607.91-1.95374,1.84057-2.93243,2.82739a.49705.49705,0,0,1-.70582,0c-.97845-.98633-1.96618-1.917-2.93231-2.82739-3.16369-2.98047-5.896-5.55469-5.896-7.88233a4.2183,4.2183,0,0,1,4.01922-3.981,3.61367,3.61367,0,0,1,3.085,1.76807c.74781,1.19385,1.2569,1.91345,1.2569,1.91345a1,1,0,0,0,1.62909.0033,22.203,22.203,0,0,1,1.2276-1.8562A4.002,4.002,0,0,1,21.273,7.94482a4.10315,4.10315,0,0,1,3.90839,3.981C25.18134,14.25342,22.449,16.82764,19.28534,19.80811Z"
				{...this.props}
			/>
		);
	}
}

export default HeartEmptyIcon;
